import ProjectsComp from '../components/projectsComp';

const Projects = () => {
    return <ProjectsComp />;
};

export default Projects;
